// src/hooks/usePeerAnalyserFunds.ts
import { useQuery } from '@tanstack/react-query'
import { fetchPeerAnalyserFunds } from '../repository/peer-analyser'
import { FundsData } from '../types/peer-analyser'
import { usePeerAnalyserStore } from '../state-management/peerAnalyserStore'

export function usePeerAnalyserFunds() {
  const selectedCategoryId = usePeerAnalyserStore((state) => state.selectedCategoryId)
  const fundNature = usePeerAnalyserStore((state) => state.fundNature)
  return useQuery<FundsData>({
    queryKey: ['peerAnalyserFunds', selectedCategoryId, fundNature],
    queryFn: () => fetchPeerAnalyserFunds(selectedCategoryId, fundNature),
    enabled: !!selectedCategoryId && !!fundNature, // only fetch if both are set
    retry: 1
  })
}
